// PRC-043 (boceto G8): página de planes en Ajustes. Growth se contrata; Autonomy
// es «Próximamente» y solo se habla con nosotros. También es Mi suscripción
// mientras la cuenta no tiene suscripción de pago.
import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import SettingsFrame from '../components/SettingsFrame';
import { Notice } from '../components/JourneyBlocks';
import { JourneyButton } from '../components/JourneyBasics';
import { BillingToggle, PlanCards, PlanComparison, useGrowthCheckout, type BillingCycle } from '../components/PlanOffer';
import { formatLongDate, openBillingPortal } from '../journeyBilling';
import { J } from '../journeyTokens';
import { PAYMENT_METHODS_LABEL } from '../pricingPlans';

const PlansPage: React.FC = () => {
  const { pricingAccess } = useAuth();
  const [cycle, setCycle] = useState<BillingCycle>('monthly');
  const checkout = useGrowthCheckout();
  const [portalBusy, setPortalBusy] = useState(false);
  const [searchParams] = useSearchParams();
  const paymentCancelled = searchParams.get('pago') === 'cancelado';
  const paid = pricingAccess?.state === 'paid';
  const { user } = useAuth();
  const onGrowth = paid && user?.tier_id === 'growth';

  const context = pricingAccess?.state === 'trial' && pricingAccess.trial_ends_at
    ? `Tu prueba termina el ${formatLongDate(pricingAccess.trial_ends_at)}`
    : pricingAccess && !pricingAccess.has_access
      ? 'Tu acceso está en pausa: contrata Growth para seguir con tus datos'
      : undefined;

  const goPortal = async () => {
    setPortalBusy(true);
    try { await openBillingPortal(); } catch { setPortalBusy(false); }
  };

  return (
    <SettingsFrame title="Planes" context={context} actions={<BillingToggle value={cycle} onChange={setCycle} />}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {paymentCancelled && <Notice tone="info">No se ha realizado ningún cargo.</Notice>}
        {checkout.error && (
          <Notice
            tone={checkout.error.exists ? 'info' : 'danger'}
            action={checkout.error.exists ? <Button color="inherit" size="small" disabled={portalBusy} onClick={goPortal}>Ir al portal</Button> : undefined}
          >
            {checkout.error.message}
          </Notice>
        )}
        <PlanCards
          cycle={cycle}
          growthAction={onGrowth
            ? <JourneyButton block kind="ghost" disabled>Tu plan actual</JourneyButton>
            : <JourneyButton block disabled={checkout.busy} onClick={() => checkout.buy(cycle)}>{checkout.busy ? 'Abriendo el pago…' : 'Contratar Growth'}</JourneyButton>}
        />
        <Box sx={{ fontFamily: J.font, fontSize: 13, color: J.muted, textAlign: 'center' }}>{PAYMENT_METHODS_LABEL}</Box>
        <PlanComparison />
      </Box>
    </SettingsFrame>
  );
};

export default PlansPage;
